import React from "react";
import Navigation from "../components/marketing/Navigation";
import HeroSection from "../components/marketing/HeroSection";
import FeatureSlider from "../components/marketing/FeatureSlider";
import ValueCards from "../components/marketing/ValueCards";
// import PricingSection from "../components/marketing/PricingSection";
import ContactSection from "../components/marketing/ContactSection";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <FeatureSlider />
      <ValueCards />
      {/* <PricingSection /> */}
      <ContactSection />

      <footer className="bg-slate-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <span className="text-slate-900 font-bold">E</span>
                </div>
                <span className="text-xl font-bold">Export Stuff</span>
              </div>
              <p className="text-slate-400 text-sm">
                Simplifying global trade for modern businesses
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-slate-400 text-sm mb-2">
                © 2026 Export Stuff. All rights reserved.
              </p>
              <p className="text-slate-500 text-xs">
                Trusted by 100+ importers and exporters worldwide
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
